<template>
  <div class="message-list-container">
    <div id="message-scroll" @click="hideShow">
      <div class="no-message" v-if="isCompleted && !isFirst">
        没有更多消息了
      </div>
      <div class="no-message" v-if="isFirst">可以开始聊天啦</div>
      <div v-for="item in messageList" :key="item.id">
        <div
          v-if="item.isRevoked"
          class="flex j-c"
          style="font-size: 24rpx; color: #666666"
          :id="'m' + item.id"
        >
          <div v-if="item.flow === 'out'" class="">撒回了一条消息</div>
          <div v-else class="">对方撒回了一条消息</div>
        </div>
        <div class="" v-else-if="item.isDeleted" :id="'m' + item.id"></div>
        <div
          v-else-if="conversation.type !== '@TIM#SYSTEM'"
          :id="'m' + item.id"
        >
          <div
            class="time-pop-mask"
            :data-value="item.time"
            v-if="showMessageTime"
          >
            <div class="showmessagetime" v-if="item.isShowTime">
              <text class="time" v-if="!item.isDeleted && !item.isRevoked"
                >{{ messageTime }}
              </text>
            </div>
          </div>
          <div
            class="time-pop-mask"
            :data-value="item.time"
            v-if="showMessageHistoryTime"
          >
            <div
              class="showmessagetime"
              v-if="
                item.isShowHistoryTime &&
                !item.isShowTime &&
                !item.isShowMoreHistoryTime
              "
            >
              <text class="time" v-if="!item.isDeleted && !item.isRevoked"
                >{{ messageHistoryTime }}
              </text>
            </div>
          </div>
          <div class="time-pop-mask" v-if="item.isShowMoreHistoryTime">
            <div class="showmessagetime">
              <text class="time">{{ newArr[item.id] }} </text>
            </div>
          </div>
          <div class="t-message-item">
            <div v-if="Show" @tap="hideShow" class="label-pop-wrap">
              <div
                class="label-pop"
                v-if="messageID === item.id"
                :class="
                  item.from == user_id
                    ? 'label-self-body'
                    : 'label-recieve-body'
                "
              >
                <div class="label-pop-mask">
                  <div
                    class="copymessage"
                    v-if="
                      item.type === 'TIMTextElem' || item.type === 'TIMFaceElem'
                    "
                    @tap="copyMessage(item)"
                  >
                    <text>复制｜</text>
                  </div>
                  <div class="deletemessage" @tap="deleteMessage(item)">
                    <text> 删除</text>
                  </div>
                  <div
                    class="revokemessage"
                    v-if="item.from == user_id"
                    @tap="revokeMessage(item)"
                  >
                    <text> ｜撤回</text>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="item.type !== 'TIMGroupTipElem'"
              :class="
                item.flow === 'out' ? 't-self-message' : 't-recieve-message'
              "
            >
              <img
                class="t-message-avatar"
                v-if="item.flow === 'in'"
                @click="toCoach(item)"
                :src="item.avatar || '/static/mine/header.png'"
              />
              <!-- <div class="read-receipts" v-if="conversation.type === 'C2C' && item.flow === 'out'">
								<div v-if="item.isPeerRead">已读</div>
								<div v-else>未读</div>
							</div> -->
              <div
                @longpress.stop="handleLongPress(item)"
                class="flex-col"
                :class="item.flow === 'out' ? 'al-end' : ''"
              >
                <div
                  class="msg-nick"
                  :class="item.flow === 'out' ? 'my-nick' : ''"
                  v-if="showName"
                >
                  {{ item.nick || "" }}
                </div>
                <TUI-TextMessage
                  @tips="handlerTips"
                  v-if="item.type === 'TIMTextElem'"
                  :message="item"
                  :isMine="item.flow === 'out'"
                ></TUI-TextMessage>
                <TUI-ImageMessage
                  v-if="item.type === 'TIMImageElem'"
                  :message="item"
                  :isMine="item.flow === 'out'"
                ></TUI-ImageMessage>
                <TUI-CustomMessage
                  v-if="item.type === 'TIMCustomElem'"
                  :message="item"
                  :isMine="item.flow === 'out'"
                ></TUI-CustomMessage>
                <TUI-MapMessage
                  v-if="item.type === 'TIMLocationElem'"
                  :message="item"
                  :isMine="item.flow === 'out'"
                ></TUI-MapMessage>
              </div>
              <img
                @click="toSelfInfo"
                class="t-message-avatar"
                v-if="item.flow === 'out'"
                :src="item.avatar || '/static/mine/header.png'"
              />
            </div>
          </div>
        </div>
        <div v-if="hasSystem(item)">
          <TUI-SystemMessage :message="getSystem(item)"></TUI-SystemMessage>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TUITextMessage from "../../message-elements/text-message/index.vue";
import TUIImageMessage from "../../message-elements/image-message/index.vue";
import TUICustomMessage from "../../message-elements/custom-message/index.vue";
import TUISystemMessage from "../../message-elements/system-message/index.vue";
import TUIMapMessage from "../../message-elements/map-message/index.vue";
import { dayjs } from "../../../base/common.js";
export default {
  data() {
    return {
      user_id: "hcs" + JSON.parse(localStorage.getItem("managerInfo")).id,
      messageID: "",
      selectedMessage: "",
      Show: false,
      avatar: "",
      userID: "",
      // 当前会话
      messageList: [],
      // 自己的 ID 用于区分历史消息中，哪部分是自己发出的
      scrolldiv: "",
      scrollTop: 0,
      triggered: true,
      nextReqMessageID: "",
      isFirst: false,
      // 下一条消息标志
      isCompleted: false, // 当前会话消息是否已经请求完毕

      UseData: "",
      messageTime: "",
      showMessageTime: false,
      firstTime: "",
      messageHistoryTime: "",
      showMessageHistoryTime: false,
      newArr: {},
      isLoad: false,
      showName: false,
      tipsList: [],
    };
  },

  components: {
    TUITextMessage,
    TUIImageMessage,
    TUICustomMessage,
    TUISystemMessage,
    TUIMapMessage,
  },
  props: {
    conversation: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    conversation: {
      handler: function (newVal, oldVal) {
        if (!newVal.conversationID) {
          return;
        }

        if (!oldVal) {
          oldVal = { conversationID: "" };
        }
        if (newVal.conversationID != oldVal.conversationID) {
          this.messageList = [];
          this.isCompleted = false;
          this.getNewMessageList(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$tim.on(
      this.$tims.EVENT.MESSAGE_READ_BY_PEER,
      this.$onMessageReadByPeer,
      this
    );
    this.$tim.on(
      this.$tims.EVENT.MESSAGE_REVOKED,
      this.$onMessageRevoked,
      this
    );
    this.$tim.getMyProfile().then((res) => {
      this.avatar = res.data.avatar;
      this.userID = res.data.user_id;
    });
  },

  destroyed() {
    // 一定要解除相关的事件绑定
    this.$tim.off(
      this.$tims.EVENT.MESSAGE_READ_BY_PEER,
      this.$onMessageReadByPeer
    );
    this.$tim.off(this.$tims.EVENT.MESSAGE_REVOKED, this.$onMessageRevoked);
  },
  methods: {
    toSelfInfo() {
      uni.navigateTo({
        url: "/pages/timMessage/selfInfo/selfInfo",
      });
    },
    hasSystem(message) {
      if (message.isDeleted && message.isRevoked) {
        return false;
      }
      let res = this.tipsList
        .map((t) => {
          return t.id;
        })
        .includes(message.id);
      return res;
    },
    getSystem(message) {
      for (let i = 0; i < this.tipsList.length; i++) {
        if (this.tipsList[i].id == message.id) {
          return this.tipsList[i];
        }
      }
      return {};
    },
    handlerTips(message) {
      if (
        !this.tipsList
          .map((t) => {
            return t.id;
          })
          .includes(message.id)
      ) {
        this.tipsList.push(message);
      }
    },
    // 获取用户体验次数
    getUserSurplus() {
      this.$http
        .request({
          url: "/",
          data: {
            user_id: uni.getStorageSync("userif_list").user_id,
          },
        })
        .then((res) => {});
    },

    // 展示消息时间
    messageTimeForShow(messageTime) {
      const interval = 5 * 60 * 1000;
      const nowTime = Math.floor(messageTime.time / 10) * 10 * 1000;
      if (this.messageList.length > 0) {
        const lastTime = this.messageList.slice(-1)[0].time * 1000;
        if (nowTime - lastTime > interval) {
          Object.assign(messageTime, {
            isShowTime: true,
          }),
            (this.messageTime = dayjs(nowTime));
          this.showMessageTime = true;
        }
      }
    },
    // 渲染历史消息时间
    showHistoryMessageTime(messageList) {
      const cut = 30 * 60 * 1000;
      for (let index = 0; index < messageList.length; index++) {
        const nowadayTime =
          Math.floor(messageList[index].time / 10) * 10 * 1000;
        const firstTime = messageList[0].time * 1000;
        if (nowadayTime - firstTime > cut) {
          const indexbutton = messageList
            .map((item) => item)
            .indexOf(messageList[index]); // 获取第一个时间大于30分钟的消息所在位置的下标
          const firstTime = nowadayTime; // 找到第一个数组时间戳大于30分钟的将其值设为初始值
          const showHistoryTime =
            Math.floor(messageList[indexbutton].time / 10) * 10 * 1000;
          Object.assign(messageList[indexbutton], {
            isShowHistoryTime: true,
          }),
            (this.firstTime = nowadayTime);
          this.messageHistoryTime = dayjs(showHistoryTime);
          this.showMessageHistoryTime = true;
          return firstTime;
        }
      }
    },
    // 拉取更多历史消息渲染时间
    showMoreHistoryMessageTime(messageList) {
      if (messageList.length > 0) {
        const showHistoryTime = messageList[0].time * 1000;
        Object.assign(messageList[0], {
          isShowMoreHistoryTime: true,
        });
        this.newArr[messageList[0].id] = dayjs(showHistoryTime);
      }
    },
    // 更新 messagelist
    updateMessageByID(deleteMessageID) {
      const deleteMessageArr = this.messageList.filter(
        (item) => item.id != deleteMessageID
      );
      this.messageList = deleteMessageArr;
    },
    // 删除消息
    deleteMessage(item) {
      this.$tim
        .deleteMessage([item])
        .then((imResponse) => {
          this.updateMessageByID(imResponse.data.messageList[0].id);
        })
        .catch(() => {
          uni.showToast({
            title: "删除失败!",
            duration: 800,
            icon: "error",
          });
        });
    },
    // 撤回消息
    revokeMessage(item) {
      this.$tim
        .revokeMessage(item)
        .then((imResponse) => {
          this.updateMessageByID(imResponse.data.data.id);
          // 消息撤回成功
        })
        .catch((imError) => {
          console.log(imError);
          uni.showToast({
            title: "超过2分钟消息不支持撤回",
            duration: 800,
            icon: "none",
          }),
            (this.Show = false);
        });
    },
    // 向对方通知消息撤回事件
    $onMessageRevoked(event) {
      this.updateMessageByID(event.data[0].id);
    },
    // 复制消息
    copyMessage(item) {
      uni.setClipboardData({
        data: item.payload.text,
        success() {},
      });
      this.Show = false;
    },
    hideShow() {
      this.Show = false;
    },
    // 获取消息ID
    handleLongPress(item) {
      if (item.status === "success") {
        this.messageID = item.id;
        this.selectedMessage = item;
        this.Show = true;
      }
    },
    refresh() {
      if (this.isCompleted) {
        (this.isCompleted = true), (this.triggered = false);
        return;
      }
      this.getMessageList(this.conversation);
      setTimeout(() => {
        this.triggered = false;
      }, 2000);
    },
    // 进入页面获取最新的消息
    getNewMessageList(conversation) {
      if (!this.isCompleted) {
        this.$tim
          .getMessageList({
            conversationID: conversation.conversationID,
            imConversationID: conversation.imConversationID,
            nextReqMessageID: this.nextReqMessageID,
            count: 15,
          })
          .then((res) => {
            const { messageList, nextReqMessageID, isCompleted } =
              res.data.data; // 消息列表。
            this.showHistoryMessageTime(messageList);
            this.nextReqMessageID = nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
            this.isCompleted = isCompleted; // 表示是否已经拉完所有消息。
            // this.messageList = messageList;
            this.messageList = [...messageList, ...this.messageList];
            this.$emit("updateMessage", this.messageList);
            if (this.messageList.length > 0) {
              this.scrollToButtom();
            }
          });
      }
    },
    // 历史消息
    getMessageList(conversation) {
      if (!this.isCompleted) {
        this.$tim
          .getMessageList({
            conversationID: conversation.conversationID,
            nextReqMessageID: this.nextReqMessageID,
            imConversationID: conversation.imConversationID,
            count: 15,
          })
          .then((res) => {
            const { messageList, nextReqMessageID, isCompleted } =
              res.data.data; // 消息列表。
            this.showMoreHistoryMessageTime(messageList);
            this.nextReqMessageID = nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
            this.isCompleted = isCompleted; // 表示是否已经拉完所有消息。
            this.messageList = [...messageList, ...this.messageList];
            if (messageList.length > 0) {
              this.$nextTick(() => {
                this.scrolldiv = "m" + messageList[messageList.length - 1].id;
              });
            }
          });
      }
    },

    // 自己的消息上屏
    updateMessageList(msg) {
      this.messageList = this.messageList.concat(msg);
      this.messageTimeForShow(msg);
      this.scrollToButtom();
      // this.scrolldiv = msg.id
    },

    // 消息已读更新
    $onMessageReadByPeer(v) {
      const data = v.data;
      data.forEach((msg) => {
        this.messageList.forEach((item) => {
          if (msg.id === item.id) {
            item.isPeerRead = true;
          }
        });
      });

      this.messageList = this.messageList;
    },
    scrollToButtom() {
      this.$nextTick(() => {
        var container = document.querySelector("#message-scroll");
        this.$emit("toBottom", { scrollTop: container.offsetHeight });
      });
    },
  },
};
</script>
<style>
@import "./index.css";
</style>